// Helpers
import { useMediaQuery } from '@helpers/useMediaQuery'
import { getStyle, getStyleSpacing } from '@helpers/getStyles'

// Styles
import styles from './Grid.module.sass'

// Types
import { Spacing } from '@interfaces/theme'
import { SpacingData } from '@interfaces/spacing'

interface GridProps {
  children: React.ReactNode
  column: {
    sm?: number
    lg?: number
  }
  gutter: {
    lg?: Spacing
    sm?: Spacing
  }
  className?: string
  spacing?: SpacingData
}

interface CustomStyles {
  marginBottom?: string
}

const Grid = ({ children, column, gutter, className, spacing }: GridProps) => {
  const isDesktop = useMediaQuery(1168)

  const customStyles: CustomStyles = {}

  if (spacing) {
    customStyles.marginBottom = getStyle(spacing, isDesktop)
  }

  return (
    <div
      className={`
      ${styles.grid} 
      ${
        styles[
          `grid-${getStyleSpacing(column, isDesktop)}-${getStyleSpacing(
            gutter,
            isDesktop
          )}`
        ]
      }
      ${className ? className : ''}
    `}
      style={customStyles}
    >
      {children}
    </div>
  )
}

export default Grid
